import { render } from "./ParentHome.vue?vue&type=template&id=737e1a94&scoped=true"
import script from "./ParentHome.vue?vue&type=script&lang=js"
export * from "./ParentHome.vue?vue&type=script&lang=js"

import "./ParentHome.vue?vue&type=style&index=0&id=737e1a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737e1a94"]])

export default __exports__